const ADAPTER_CAPABILITY_PREFIXES = ['IDENTITY.TPA_', 'INCOME.GET_TX_', 'AI.GENERATE', 'DE.'];

export function isAdapterBackedCapability(capability: string): boolean {
  return ADAPTER_CAPABILITY_PREFIXES.some(p => capability.startsWith(p));
}
